import PageBuilder from '@commons/pagebuilder';
import type { DrupalNode, DrupalParagraph } from '@commons/types/drupal';

// Type definition for the Node paragraph properties.

type Props = DrupalParagraph & {
  reference: DrupalNode;
};

/**
 * Node paragraph component.
 */

const NodeParagraph = ({ reference }: Props) => {
  return PageBuilder.renderNode(reference);
};

export default NodeParagraph;
